import { TFunction } from "i18next";
import { StyledImg, StyledNoAccountBackgroundBox, StyledNoAccountWrapperBox, StyledNoLinkedDesc, StyledNoLinkedHeader } from "../styles";

interface NoLinkedAccountProps {
  t: TFunction;
  resourceUrl: string;
}

const NoLinkedAccount = ({t, resourceUrl}: NoLinkedAccountProps) => {
  return (
    <StyledNoAccountWrapperBox>
      <StyledNoAccountBackgroundBox>
        <StyledImg sx={{ width: { sm: '100%' } }} src={`${resourceUrl}/images/accounts_grey.svg`} />
        <StyledNoLinkedHeader variant="body1">{t('noLinkedAccounts')}</StyledNoLinkedHeader>
        <StyledNoLinkedDesc variant="body2">{t('connectSocialAccount')}</StyledNoLinkedDesc>
      </StyledNoAccountBackgroundBox>
    </StyledNoAccountWrapperBox>
  );
}


export default NoLinkedAccount;
